import { useContactTracking, useContactContext } from "@/contexts/contact";
import { useTrackingAvDistributionType, useTrackingLeadForm } from "@/hooks";
import { useAuthenticationTracking } from "@/hooks/tracking/useAuthenticationTracking";
const buildFormConsent = (data) => {
    const consents = [];
    if ("newsletterOptout" in data &&
        !data.newsletterOptout &&
        data.newsletterOptInPreference) {
        consents.push(`marketing_optout-${data.newsletterOptInPreference}`);
    }
    if (data.offerOptin) {
        consents.push("partner_optin");
    }
    return consents.join("|");
};
export const useSendLeadTracking = () => {
    const { authTrackingData } = useAuthenticationTracking();
    const { leadValue } = useContactTracking();
    const { defaultMessage } = useContactContext();
    const getAdditionalProps = (data, av_zone) => {
        var _a;
        const av_form_subscription_consent = buildFormConsent(data);
        const filledFormKeysPipe = Object.entries(data)
            .filter(([key, value]) => key !== "newsletterOptInPreference" &&
            value != null &&
            !(typeof value === "string" && value.trim() === ""))
            .map(([key]) => key)
            .join("|");
        const isDefaultMessageChanged = ((_a = data.message) !== null && _a !== void 0 ? _a : "").trim() !== (defaultMessage !== null && defaultMessage !== void 0 ? defaultMessage : "").trim();
        return {
            additionalProps: {
                av_user: Object.assign(Object.assign(Object.assign({}, authTrackingData), leadValue), { project: data.isOwner === true ? "IsOwner" : "Unknown" }),
                av_attached_file: data.shareSeekerProfile ? "seeker_profile" : "none",
                av_form_subscription_consent,
                av_zone,
                av_form_message_edited: isDefaultMessageChanged ? 1 : 0,
                av_form_fields: filledFormKeysPipe,
            },
        };
    };
    const distributionType = useTrackingAvDistributionType();
    const eventNameOk = distributionType === "1"
        ? "lead_classified_form_submit_rent"
        : "lead_classified_form_submit_buy";
    const eventNameConfirm = distributionType === "1"
        ? "lead_classified_form_confirm_rent"
        : "lead_classified_form_confirm_buy";
    const leadFormOk = useTrackingLeadForm({
        event: eventNameOk,
    });
    const leadFormConfirm = useTrackingLeadForm({
        event: eventNameConfirm,
    });
    return {
        leadFormOk,
        leadFormConfirm,
        getAdditionalProps,
    };
};
